import { AfterViewChecked, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { environment } from '@environments/environment';
import { BreakpointService } from '@services/breakpoint.service';
import { CommonService } from '@services/common-service';
import { GoogleAnalyticsEventService } from '@services/google-analytics-events.service.service';
import { NavigationService } from '@services/navigation-service';
import { ToastService } from '@services/toastService/toastMessage.service';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { SubSink } from 'subsink';
import { manipulateFileIngestData } from '../related-content';
import { FILE_INGEST_API_FILTERS, FILE_INGEST_COLUMNS, FILE_INGEST_DEFAULT_TABLE_PARAMS, FILE_INGEST_REQUEST_STATUS_DETAILS, FILE_INGEST_STATUS_FILTERS, TableColumns } from '../related-content-utils';

type NBCApp = 'guest-tracker' | 'ncx' | 'news-search' | 'producer-dashboard';

@Component({
  selector: 'fileIngest-related-content',
  templateUrl: './fileIngest-related-content.component.html',
  styleUrls: ['../story-related-content.component.scss', './fileIngest-related-content.component.scss'],
})
export class FileIngestRelatedContentComponent implements OnInit, OnDestroy, OnChanges, AfterViewChecked {

  // Story information
  @Input() storyId: number = 0;

  @Input() relatedContentHeight: number = 0;

  @Input() relatedContentTop: number = 0;

  @Input() showTempModal: boolean = false;

  @Output() totalRecords: EventEmitter<number> = new EventEmitter<number>();

  isLoaded: boolean = true;

  relatedContentData: any = [];

  headerHeight: number = 0;

  tableHeight: number = 0;

  heightToBeRemoved: number = 0;

  preferenceColumns: { [key: string]: TableColumns } = {};

  columns: any;

  private subs = new SubSink();

  submittedDateSortOrder: string = null;
  modifiedDateSortOrder: string = null;
  airDateSortOrder: string = null;

  apiQueryFilters: any;
  tableParams: any;
  statusFilters: any;
  requestStatusDetails: any;

  idSearchVisible: boolean = false;
  idSearchText: string = '';

  showOrProjectSearchVisible: boolean = false;
  showOrProjectSearchText: string = '';
  priorShowOrProjectSearchText: string = '';

  requesterSearchVisible: boolean = false;
  requesterSearchText: string = '';
  priorRequesterSearchText: string = '';

  destinationSearchVisible: boolean = false;
  destinationSearchText: string = '';
  priorDestinationSearchText: string = '';

  resetStatusButton: boolean = false;
  requestStatusVisible: boolean = false;
  requestStatusTypeFilterStatus: boolean = false;

  screenSize: any;

  searchText: Subject<string> = new Subject();

  private destroy$ = new Subject();

  constructor(
    private breakpointService: BreakpointService,
    private cService: CommonService,
    private toastService: ToastService,
    private gaService: GoogleAnalyticsEventService,
    private navigationService: NavigationService
  ) { }

  ngOnInit() {

    this.breakpointService.breakpoints$.subscribe((breakpoints: any) => {
      this.screenSize = breakpoints;
    });

    this.searchText.pipe(debounceTime(500), takeUntil(this.destroy$)).subscribe(() => {

      this.searchId();
    });

    this.apiQueryFilters = JSON.parse(JSON.stringify(FILE_INGEST_API_FILTERS));

    this.tableParams = JSON.parse(JSON.stringify(FILE_INGEST_DEFAULT_TABLE_PARAMS));

    this.statusFilters = JSON.parse(JSON.stringify(FILE_INGEST_STATUS_FILTERS));

    this.requestStatusDetails = JSON.parse(JSON.stringify(FILE_INGEST_REQUEST_STATUS_DETAILS));

    this.loadColumns();

    // this.totalRecords.emit(0);

    if (this.storyId)
      this.loadRelatedContent(true);
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.storyId && changes.storyId.currentValue) {

      // this.loadRelatedContent();

    }

  }

  ngAfterViewChecked() {

    // this.windowResizeEvent();

  }


  /**
   * Resize event to calculate the height of the inner body to enable scroll
   **/
  public windowResizeEvent() {

    // this.resizeWindow.next('resize');

  }


  /**
* Lifecycle hook that is called when the component is destroyed.
* 
* This method performs the following cleanup tasks:
* - Completes the `destroy$` observable to prevent memory leaks.
* - Removes the custom CSS property `--body-tab-height` from the document's root element.
* - Calls the `unsetBannerSessionHeight` method of `bannerSessionResizeObserverService` to clean up any session-specific banner height settings.
*/
  ngOnDestroy() {

    this.subs.unsubscribe();

    this.destroy$.complete();

  }

  /**
   * Make API call to get the related content for the story
   *
   */
  loadRelatedContent(emitTotalRecords: boolean = false) {

    this.isLoaded = false;

    this.apiQueryFilters.storyId = this.storyId;//1733260492448;//1724947933414;

    let apiResponse = this.cService.serviceRequestCommon('post', environment.fileIngestRequestAPI, '', this.apiQueryFilters);

    apiResponse.subscribe((res: any) => {

      let results = res?.results || [];

      if (Array.isArray(results)) {

        manipulateFileIngestData(res?.results);

        this.relatedContentData = [...results];

        // console.log('related Content', { relatedContent: this.data, response });

        this.tableParams.total = res.total || 0;

        if (emitTotalRecords) {
          this.totalRecords.emit(this.tableParams.total);
        }

      }

    }, (error: any) => {

      console.error('Load Related Content', error);

      this.toastService.createMessage('error', 'Error while loading related content. Please try again.');

    }).add(() => {

      this.isLoaded = true;

    });

  }

  get isMobile(): boolean {

    return this.breakpointService.isMobile.value;

  }


  /**
    * Changing pages
    * @param page {number}
    *
    */
  onChangePage(page: number) {

    this.tableParams.page = page;
    this.apiQueryFilters.start = ((page - 1) * this.apiQueryFilters.count) + 1;

    this.loadRelatedContent();

  }

  /**
   * Changing number of items to display per page
   * @param limit {number}
   *
   */
  onChangePageSize(limit: number) {

    this.tableParams.limit = limit;
    this.apiQueryFilters.count = limit;

    // If Page size changed then we need to reset page index as 1 as well start also
    const page = 1;
    this.tableParams.page = page;
    this.apiQueryFilters.start = ((page - 1) * this.apiQueryFilters.count) + 1;

    this.loadRelatedContent();
  }

  navigationTo(id: string) {

  }



  loadColumns() {

    this.preferenceColumns = {};

    this.columns = JSON.parse(JSON.stringify(FILE_INGEST_COLUMNS));;

    this.columns.forEach((column: TableColumns) => {
      this.preferenceColumns[column.value] = column;
    });

  }

  typeFilterEvent(event: any) {

    this.resetTableParams();

    if (event?.length == 0)
      this.apiQueryFilters.Type = [];
    else
      this.apiQueryFilters.Type = event;

    this.loadRelatedContent();

  }

  statusFilterEvent(event: any) {

    this.resetTableParams();

    if (event?.length == 0)
      this.apiQueryFilters.status = ["NEW", "REVISED", "IN PROGRESS", "COMPLETED"];
    else
      this.apiQueryFilters.status = event;

    this.loadRelatedContent();

  }

  submittedDateFilterEvent(event: any) {

    this.resetTableParams();

    if (event?.length == 0)
      this.apiQueryFilters.submittedDate = [];
    else
      this.apiQueryFilters.submittedDate = event;

    this.loadRelatedContent();

  }

  submittedDateSortEvent(event: any) {

    if (event === null && this.apiQueryFilters.sortField !== 'created') return;

    this.resetTableParams();

    if (event == null) {
      this.apiQueryFilters.sortField = 'created';
      this.apiQueryFilters.sortOrder = 'descending';
    } else {
      this.apiQueryFilters.sortField = 'created';
      this.apiQueryFilters.sortOrder = (event == 'ascend') ? 'ascending' : 'descending';
    }

    this.submittedDateSortOrder = event;

    this.loadRelatedContent();
  }

  modifiedDateSortEvent(event: any) {

    if (event === null && this.apiQueryFilters.sortField !== 'modified') return;

    this.resetTableParams();

    if (event == null) {
      this.apiQueryFilters.sortField = 'created';
      this.apiQueryFilters.sortOrder = 'descending';
    } else {
      this.apiQueryFilters.sortField = 'modified';
      this.apiQueryFilters.sortOrder = (event == 'ascend') ? 'ascending' : 'descending';
    }

    this.modifiedDateSortOrder = event;

    this.loadRelatedContent();
  }

  airDateSortEvent(event: any) {

    if (event === null && this.apiQueryFilters.sortField !== 'airDate') return;

    this.resetTableParams();

    if (event == null) {
      this.apiQueryFilters.sortField = 'created';
      this.apiQueryFilters.sortOrder = 'descending';
    } else {
      this.apiQueryFilters.sortField = 'airDate';
      this.apiQueryFilters.sortOrder = (event == 'ascend') ? 'ascending' : 'descending';
    }

    this.airDateSortOrder = event;

    this.loadRelatedContent();
  }

  resetTableParams() {

    const currentTableParams = JSON.parse(JSON.stringify(this.tableParams));

    let defaultTableParams = JSON.parse(JSON.stringify(FILE_INGEST_DEFAULT_TABLE_PARAMS));

    defaultTableParams.limit = currentTableParams.limit;

    this.tableParams = JSON.parse(JSON.stringify(defaultTableParams));

    this.apiQueryFilters.start = 1;

  }

  /** 
   * Search for id
  */
  search() {
    this.searchText.next(this.idSearchText);
  }

  searchId(): void {
    this.resetTableParams();
    this.idSearchVisible = false;
    if (this.idSearchText.length === 0) {
      this.apiQueryFilters.filter.id = '*';
    } else {
      this.apiQueryFilters.filter.id = this.idSearchText + '*';
    }
    this.loadRelatedContent();
  }

  resetIdSearch(): void {
    this.idSearchVisible = false;
    this.idSearchText = '';
    this.apiQueryFilters.filter.id = '*';
    this.loadRelatedContent();
  }

  /** 
  * Search for a show
 */
  searchShowOrProject(): void {
    this.resetTableParams();
    this.showOrProjectSearchVisible = false;
    if (this.showOrProjectSearchText.length === 0) {
      this.apiQueryFilters.showUnit = [];
    } else {
      this.apiQueryFilters.showUnit = [this.showOrProjectSearchText + '*'];
    }
    this.priorShowOrProjectSearchText = this.showOrProjectSearchText;
    this.loadRelatedContent();
  }

  resetShowOrProjectSearch(): void {
    this.showOrProjectSearchVisible = false;
    this.showOrProjectSearchText = '';
    this.apiQueryFilters.showUnit = [];
    this.priorShowOrProjectSearchText = '';
    this.loadRelatedContent();
  }

  ShowOrProjectVisibleChange(event: boolean): void {
    if (!event && this.showOrProjectSearchText !== this.priorShowOrProjectSearchText) {
      this.searchShowOrProject();
    }
  }

  /**
   * Search for a Requester
   */
  searchRequester(): void {
    this.resetTableParams();
    this.requesterSearchVisible = false;
    if (this.requesterSearchText.length === 0) {
      this.apiQueryFilters.requester = '';
    } else {
      this.apiQueryFilters.requester = this.requesterSearchText + '*';
    }
    this.priorRequesterSearchText = this.requesterSearchText;
    this.loadRelatedContent();
  }

  resetRequesterSearch(): void {
    this.requesterSearchVisible = false;
    this.requesterSearchText = '';
    this.apiQueryFilters.requester = '';
    this.priorRequesterSearchText = '';
    this.loadRelatedContent();
  }

  requesterVisibleChange(event: boolean): void {
    if (!event && this.requesterSearchText !== this.priorRequesterSearchText) {
      this.searchRequester();
    }
  }

  /**
 * Search for a destination
 */
  searchDestination(): void {
    this.resetTableParams();
    this.destinationSearchVisible = false;
    if (this.destinationSearchText.length === 0) {
      delete this.apiQueryFilters.filter.destinations;
    } else {
      this.apiQueryFilters.filter.destinations = this.destinationSearchText + '*';
    }
    this.priorDestinationSearchText = this.destinationSearchText;
    this.loadRelatedContent();
  }

  resetDestinationSearch(): void {
    this.destinationSearchVisible = false;
    this.destinationSearchText = '';
    delete this.apiQueryFilters.filter.destinations;
    this.priorDestinationSearchText = '';
    this.loadRelatedContent();
  }

  destinationVisibleChange(event: boolean): void {
    if (!event && this.destinationSearchText !== this.priorDestinationSearchText) {
      this.searchDestination();
    }
  }

  /**
* Open selected ProdReq app for the environment
*
*/
  openApp(url: string, key: NBCApp): boolean {

    if (this.navigationService.isIOSMobileApp.value) {
      return true;
    } else {
      const win = window.open();
      if (win) {
        win.opener = null;
        win.location.href = url;
        this.gaService.sendEvent('Story Landing - Related Content', `Open ${key}`, url, 1);
        return false;
      }
    }
  }

  windowResize() {
    // this.heightToBeRemoved = (32 + 16) + (16 * 3) + (24 * 2) + (40 * 2);

    // this.tableHeight = this.relatedContentHeight - this.heightToBeRemoved;

    // this.resizeColumnWidths();
  }

  resizeColumnWidths() {

    let screen;

    const xxlScreen = [{ value: 'IDSTATUS', width: 199 }, { value: 'DESTINATION', width: 280 }, { value: 'REQUESTER', width: 240 }, { value: 'SUBMITTED', width: 188 }, { value: 'MODIFIED', width: 148 }, { value: 'SHOWPROJECT', width: 280 }, { value: 'AIRDATE', width: 120 }];

    const xlScreen = [{ value: 'IDSTATUS', width: 199 }, { value: 'DESTINATION', width: 280 }, { value: 'REQUESTER', width: 240 }, { value: 'SUBMITTED', width: 188 }, { value: 'MODIFIED', width: 148 }, { value: 'SHOWPROJECT', width: 280 }, { value: 'AIRDATE', width: 120 }];

    const largeScreen = [{ value: 'IDSTATUS', width: 199 }, { value: 'DESTINATION', width: 280 }, { value: 'REQUESTER', width: 240 }, { value: 'SUBMITTED', width: 188 }, { value: 'MODIFIED', width: 148 }, { value: 'SHOWPROJECT', width: 280 }, { value: 'AIRDATE', width: 120 }];

    const mediumScreen = [{ value: 'IDSTATUS', width: 0 }, { value: 'DESTINATION', width: 0 }, { value: 'REQUESTER', width: 0 }, { value: 'SUBMITTED', width: 0 }, { value: 'MODIFIED', width: 0 }, { value: 'SHOWPROJECT', width: 0 }, { value: 'AIRDATE', width: 0 }];

    const smallScreen = [{ value: 'IDSTATUS', width: 0 }, { value: 'DESTINATION', width: 0 }, { value: 'REQUESTER', width: 0 }, { value: 'SUBMITTED', width: 0 }, { value: 'MODIFIED', width: 0 }, { value: 'SHOWPROJECT', width: 0 }, { value: 'AIRDATE', width: 0 }];

    const xsmallScreen = [{ value: 'IDSTATUS', width: 0 }, { value: 'DESTINATION', width: 0 }, { value: 'REQUESTER', width: 0 }, { value: 'SUBMITTED', width: 0 }, { value: 'MODIFIED', width: 0 }, { value: 'SHOWPROJECT', width: 0 }, { value: 'AIRDATE', width: 0 }];

    screen = this.screenSize?.small ? xsmallScreen : this.screenSize?.small ? smallScreen : this.screenSize?.medium ? mediumScreen : this.screenSize?.large ? largeScreen : this.screenSize?.xlarge ? xlScreen : xxlScreen;


    screen.forEach((column: any) => {
      this.preferenceColumns[column.value].width = column.width;
    });
  }

  closeModal() {
    this.showTempModal = false;
  }

  visibleChangeEventRequestStatus(event: any) {
    // if(!event && this.resetStatusButton)
    if (!event) {
      this.requestStatusOkEvent();
    }
  }


  /**
  * Search column filter request status
  *
  * @param listOfSearchName
  * @param selectedItem
  */
  requestStatusTypeSearch(listOfSearchName: any, selectedItem: any) {
    selectedItem.byDefault = listOfSearchName;
    this.resetStatusButton = false;
    this.resetStatusButton = this.statusFilters.some(
      (x: any) => x.byDefault === true
    );
    if (this.resetStatusButton) return;
  }

  /**
* Reset selected request Status search column filter request
*
*/
  requestStatusResetEvent() {
    this.resetTableParams();
    this.resetStatusButton = false;
    this.requestStatusVisible = false;
    this.requestStatusTypeFilterStatus = false;
    let resetStatusValue: string[] = [];

    resetStatusValue = this.statusFilters.map((val: any) => {
      val.byDefault = false;
      return val.value;
    });
    this.apiQueryFilters.status = ["NEW", "REVISED", "IN PROGRESS", "COMPLETED"];
    this.loadRelatedContent();
  }

  /**
 * Search column filter request
 *
 */
  requestStatusOkEvent() {
    this.resetTableParams();
    this.requestStatusVisible = false;
    let filterValue: any[] = [];
    this.requestStatusTypeFilterStatus = false;
    this.resetStatusButton = false;
    this.statusFilters.map((obj: any) => {
      if (obj.byDefault) {
        filterValue.push(obj.value);
        this.resetStatusButton = true;
        this.requestStatusTypeFilterStatus = true;
      }
    });
    if (filterValue && filterValue.length) {
      this.apiQueryFilters.status = filterValue;
    } else {
      this.apiQueryFilters.status = ["NEW", "REVISED", "IN PROGRESS", "COMPLETED"];
    }
    this.loadRelatedContent();
  }

}


